import { FC } from "react";
import DeviceHubIcon from "@mui/icons-material/DeviceHub";
import HomeIcon from "@mui/icons-material/Home";
import { ListItemLink } from "./list-item-link";
import { OpenApiIcon } from "../components/open-api-icon";
import HistoryIcon from "@mui/icons-material/History";
import { People } from "@mui/icons-material";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";

export const MainListItems: FC = () => {
  return (
    <>
      <ListItemLink primary="Home" icon={<HomeIcon />} to="/" />
      <ListItemLink
        primary="Magic Events"
        icon={<HistoryIcon />}
        to="/magic-events"
      />
      <ListItemLink
        primary="Dead Letters"
        icon={<ReportProblemIcon />}
        to="/dead-letters"
      />
      <ListItemLink
        primary="Record Matching"
        icon={<People />}
        to="/record-matching"
      />
      <ListItemLink
        primary="Webhooks"
        icon={<DeviceHubIcon />}
        to="/webhooks"
      />
      <ListItemLink
        primary="Open API"
        icon={<OpenApiIcon />}
        to="/private-api-doc"
      />
    </>
  );
};
